import {apiFetch} from './api.js'

export const searchNameByInitial = async(input) => {
    const endPoint = process.env.REACT_APP_URL_USER_SEARCH_NAME_BY_INITIAL

    try{
        const response = await apiFetch(endPoint + input)

        const data = await response.json()

        if(!response.ok) return {status: false}

        return data

    }catch(err){
        throw new Error(err)
    }
}

export const showUsers = async(pageNumber) => {
    const endPoint = `${process.env.REACT_APP_URL_SHOW_USERS_BY_PAGE}?page=${pageNumber}&limit=8`

    try{
        const response = await apiFetch(endPoint)

        if(!response.ok) return {status: false}

        const data = await response.json()

        return data
    }catch(err){
        throw new Error(err)
    }
}

export const deleteUser = async(id_user) => {
    const endPoint = process.env.REACT_APP_URL_DELETE_USER

    try{
        await apiFetch(endPoint, {
            method: 'DELETE',
            body: JSON.stringify({
                    id_user: id_user
            })
        })
    }catch(err){
        console.error(err)
    }
}

export const getDesktopToken = async() => {
    const endPoint = process.env.REACT_APP_URL_SHOW_TOKEN_DESKTOP

    try{
        const response = await apiFetch(endPoint)
        const data = await response.json()
        return data
    }catch(err){
        console.error(err)
    }
}